<template v-if="message">
    <div class="message">
      <template v-if="['image', 'ptt', 'audio', 'document', 'message', 'media'].includes(message.type)">
        <v-layout
          row
          align-center
          class="mb-3"
          :class="{ reverse: message.origin }"
          :key="`chat-room-message-layout-${index}`">
          <v-flex shrink :class="{ 'mr-2': !message.origin, 'ml-2': message.origin }">
            <v-avatar
              size="50px"
              color="k-orange-linear">
              <h2 class="avatar-text" v-if="message.origin === 0">
                {{ chat | getName | firstChar | upperCase }}
              </h2>
              <h2 class="avatar-text" v-else>
                {{ $auth.user().company.name | firstChar | upperCase }}
              </h2>
            </v-avatar>
          </v-flex>
          <v-flex>
            <v-layout
              row
              wrap
              :class="{ reverse: message.origin }">
              <div class="px-3 mb-0 py-2 message-chip d-inline-block white" v-viewer="viewerOptions">
                <template v-if="message.user && message.origin === 1 && chat.channel_id !== 1">
                  <p class="subName mb-0">
                    {{ this.message.user.first_name }} {{ this.message.user.last_name }}
                  </p>
                </template>
                <div v-if="message.type === 'message'" v-html="removeTags(message.text, 'style')"></div>
                <div v-else-if="['image', 'ptt', 'audio', 'document'].includes(message.type)">
                  <file-streamer
                    :url="'/file/stream'"
                    :location="message.text"
                    :expire-time="480"
                    :params="{}"
                    @loaded="sourceCharged"
                  >
                  <!-- expire time es en minutos -->
                    <template slot-scope="{ src }">
                      <div v-if="message.type === 'image'" >
                        <img @error="source = 'nothing'" v-if="Object.keys(src.src || {}).length" :src="src.src" :key="`image-${src.src}`">
                      </div>
                      <div v-if="message.type === 'ptt' || message.type === 'audio'" >
                        <audio
                          controls
                          :src="src.src"
                          v-if="Object.keys(src.src || {}).length" :key="`audio-${src.src}`">
                        </audio>
                      </div>
                      <div v-else-if="message.type === 'document'" >
                          <div v-if="src.src && source != 'nothing'">
                            <div v-html="message.text.split('/').pop()"></div>
                            <v-layout>
                              <v-flex xs12 class="text-xs-center">
                                <v-btn
                                  class="k-orange-linear-text k-orange-linear-underline elevation-0"
                                  round
                                  @click.native="openInBlank(message.text.split('/').pop(), source)">
                                  DESCARGAR
                                </v-btn>
                              </v-flex>
                            </v-layout>
                          </div>
                      </div>
                    </template>
                  </file-streamer>
                  <template>
                    <template v-if="source == null">
                      <div v-if="source != 'nothing'" :class="{'text-xs-right': message.origin}">
                        <v-icon small>fas fa-spinner fa-pulse</v-icon>
                      </div>
                    </template>
                    <template v-if="source == 'nothing'">
                      <span class="headline">
                        <v-icon color="red" small>fas fa-times</v-icon>
                        <p class="caption-text">El elemento no se ha podido obtener.</p>
                      </span>
                    </template>
                  </template>
                </div>
                <template v-if="hasTemplate">
                  <strong>Archivos adjuntos:</strong>
                  <div
                  v-for="(file, index) in message.files"
                  :key="`message-file-item-${index}`">
                    <file-streamer
                      :url="'/file/stream'"
                      :location="file.location"
                      :expire-time="480"
                      :params="{}">
                      <template slot-scope="{ src }">
                        <a
                          href="#"
                          @click="openInBlank(file.original_name, src.src)">
                          <small>{{ file.original_name }}</small>
                        </a>
                      </template>
                    </file-streamer>
                  </div>
                </template>
                <div v-if="message.caption">
                  <div class="caption-text" v-html="message.caption"></div>
                </div>
                <div v-else>
                  <template v-if="message.text">
                    <div class="attachment-caption" v-if="message.text.caption && chat.channel_id === 1 " v-html="removeTags(message.text.caption, 'style')"></div>
                    <template>
                      <div v-for="(attachment, attachmentIndex) in message.text.files" :key="`attachment-${attachmentIndex}`">
                        <div v-if="attachment.type === 'image'">
                          <img @error="source = 'nothing'" :src="attachment.url" :alt="attachment.filename" >
                        </div>
                        <a v-else class="attachment" @click="forceFileDownload(attachment)" :href="attachment.url" target="_blank">
                          <span class="fa-stack fa-2x">
                            <i class="far fa-file fa-stack-2x"></i>
                            <span class="fas fa-stack-1x" style="font-size: .5em !important">{{ attachment.extension }}</span>
                          </span>
                          {{ attachment.filename }}
                        </a>
                      </div>
                    </template>
                    <div class="attachment-caption" v-if="message.text.caption && chat.channel_id === 7" v-html="removeTags(message.text.caption, 'style')"></div>
                  </template>
                </div>
                <template v-if="message.user && message.origin === 1 && chat.channel_id === 1">
                  <p class="subName mb-0">
                    {{ this.message.user.first_name }} {{ this.message.user.last_name }}
                  </p>
                </template>
                <template v-if="message.status === 'Pendiente'">
                  <div :class="{'text-xs-right': message.origin}">
                    <v-icon small>fas fa-spinner fa-pulse</v-icon>
                  </div>
                </template>
              </div>
            </v-layout>
            <div
              class="mt-1"
              :class="{ 'text-xs-right mr-3': message.origin, 'text-xs-left ml-2': !message.origin}">
              <small class="caption text--secondary ma-0">
                {{ formatDate(message.created_at, 'YYYY-MM-DD HH:mm:ss', 'hh:mm a') }}
                <template
                  v-if="message.status === 'Error'"
                >
                  <br>
                  <v-icon color="red" small>fas fa-times</v-icon>Error
                </template>
              </small>
            </div>
          </v-flex>
        </v-layout>
      </template>
      <div
        v-else
        class="layout row mb-3"
        :data-id="this.message.id"
        :key="`chat-room-message-chip-${this.index}`">
        <v-chip
          v-ripple
          v-model="this.message.isOpen"
          @click.native="changeChatCategory(message.id, message.chat_category_id)"
          class="message-chip mr-auto ml-auto d-inline-block pa-2 movement-chip text-xs-center"
          @input="deleteMovement(this.message.id)">
          <p class="d-inline-block mb-0 mr-2">
            {{ this.message.chat_category ? this.message.chat_category.name : 'Categoría eliminada' }}
            <template
              v-if="message.type === 'payment_promise' || message.type === 'next_contact'">
              {{ this.message[message.type] | moment('DD/MM/YYYY') }}
            </template>
          </p>
          <v-icon small>fa-pen</v-icon>
        </v-chip>
      </div>
    </div>
  </template>


  <script>
  import _ from 'lodash';
  import moment from 'moment';
  import chatCenterMixin from '@/mixins/chatCenterMixin';
  import FileStreamer from '@/components/global/FileStreamer/FileStreamer'

  export default {
    components: {
      FileStreamer,
    },
    props: {
        message: {
            type: Object,
            default: () => {},
            required: true,
        },
        index: {
            type: Number,
        },
        chat: {
          type: Object,
          default: () => {},
        },
    },
    mixins: [
      chatCenterMixin,
    ],
    mounted(){
      //
    },
    data() {
      return {
        show: false,
        messageId: 0,
        chatCategoryId: 0,
        viewerOptions: {
            url: 'data-source',
        },
        activeAudio: null,
        audio: null,
        duration: 0,
        source: null,
      };
    },
    filters: {
      moment(date, to) {
        return moment(date).format(to);
      },
    },
    computed: {
      extension() {
        const types = ['image', 'audio', 'ptt', 'document'];
        if (types.includes(this.message.type)) {
          return this.message.text.split('.')[1];
        }
        return '';
      },
      hasTemplate() {
        return !!this.message.template_id && (this.message.files || []).length > 0;
      },
    },
    methods: {
      deleteMovement(id) {
        this.axios.delete(`chat_center_messages/${id}`).catch(() => {});
      },
      sourceCharged(source) {
        if (source != null) {
          this.source = source;
        } else {
          this.source = 'nothing';
        }
      },
      buildAudio(audio) {
        const playButton = audio.parentElement.querySelector('.playButton');
        const playhead = audio.parentElement.querySelector('.playhead');
        const timeline = audio.parentElement.querySelector('.timeline');
        if (!playButton || !playhead || !timeline) {
          return;
        }
        const timelineWidth = timeline.offsetWidth - playhead.offsetWidth;

        audio.addEventListener('canplaythrough', () => {
          this.duration = audio.duration;
          if ((this.duration === 0 || !isFinite(this.duration))) {
            this.source = 'nothing';
          } else {
            this.source = this.audio.src;
          }
        }, false);

        audio.addEventListener('play', () => {
          this.$emit('activeAudio', audio);
          this.activeAudio = audio;
        });

        function getPosition(el) {
          const bounding = el.getBoundingClientRect().left;
          return isFinite(bounding) && !isNaN(bounding) ? bounding : 0;
        }
        function clickPercent(event) {
          return (event.clientX - getPosition(timeline)) / timelineWidth;
        }
        function timeUpdate() {
          const playPercent = timelineWidth * (audio.currentTime / this.duration);
          playhead.style.marginLeft = `${playPercent}px`;
          if (audio.currentTime === this.duration) {
            playButton.querySelector('i').className = 'fas fa-play';
          }
        }
        function moveplayhead(event) {
          const newMargLeft = event.clientX - getPosition(timeline);
          if (newMargLeft >= 0 && newMargLeft <= timelineWidth) {
            playhead.style.marginLeft = `${newMargLeft}px`;
          }
          if (newMargLeft < 0) {
            playhead.style.marginLeft = '0px';
          }
          if (newMargLeft > timelineWidth) {
            playhead.style.marginLeft = `${timelineWidth}px`;
          }
        }

        playButton.addEventListener('click', () => {
          if (audio.paused) {
            audio.play();
            playButton.querySelector('i').className = 'fas fa-pause';
          } else {
            audio.pause();
            playButton.querySelector('i').className = 'fas fa-play';
          }
        });

        audio.addEventListener('timeupdate', timeUpdate, false);

        timeline.addEventListener('click', (event) => {
          try {
            moveplayhead(event, timeline, timelineWidth, playhead);
            audio.currentTime = this.duration * clickPercent(event, timeline, timelineWidth); // eslint-disable-line
          } catch (error) {
            // eslint-disable-next-line
            console.log(error);
          }
        }, false);

        playhead.addEventListener('mousedown', () => {
          audio.dataset.onplayhead = true; // eslint-disable-line
          window.addEventListener('mousemove', moveplayhead, true);
          audio.removeEventListener('timeupdate', timeUpdate, false);
        }, false);

        playhead.addEventListener('mouseup', () => {
          try {
            if (audio.dataset.onplayhead) {
              window.removeEventListener('mousemove', moveplayhead, true);
              audio.currentTime = this.duration * clickPercent(event, timeline, timelineWidth); // eslint-disable-line
              audio.addEventListener('timeupdate', timeUpdate, false);
            }
            audio.dataset.onplayhead = false; // eslint-disable-line
          } catch (error) {
            // eslint-disable-next-line
            console.log(error);
          }
        }, false);
      },
      updateChatCategory($event) {
        const index = this.chat.chat_center_messages.findIndex(item => item.id === this.messageId);
        if (index !== -1) {
          this.$set(this.chat.chat_center_messages, index, $event);
        }
        this.$emit('updateChatCategory', $event);
      },
      removeTags(text, tag) {
        if (this.chat.channel_id === 1) {
          const div = document.createElement('div');
          div.innerHTML = text;
          const styles = div.querySelectorAll(tag);
          if ((styles || []).length) {
            for (let i = 0; i < styles.length; i++) {
              styles[i].remove();
            }
          }
          return div.innerHTML;
        }
        return text;
      },
      changeChatCategory(id, categoryId) {
        this.show = true;
        this.messageId = id;
        this.chatCategoryId = categoryId;
        this.$emit('changeChatCategory', id, categoryId);
      },
      formatDate(date, initialFormat, outputFormat) {
        const dateFormatted = moment.utc(date);
        if (dateFormatted === 'Invalid date') {
          return '';
        }
        return dateFormatted.local().format(outputFormat);
      },
      openInBlank(filename, url){
        let link = document.createElement("a");
        link.style.display = 'none';
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.setAttribute("target", "_blank");
        link.click();
        document.body.removeChild(link);
      },
      forceFileDownloadV2(filename, url){
        const instance = this.axios.create({
          baseURL: "",
          responseType: 'blob',
        });
        instance.get(url)
        .then(response => {
          const blob = response.data;
          let url = window.URL.createObjectURL(blob);
          let link = document.createElement("a");
          link.style.display = 'none';
          link.href = url;
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }).catch((e) => {
          //
        });
      },
      forceFileDownload(file) {
        // const fileName = file.filename;
        // const url = window.URL.createObjectURL(new Blob([file.url]));;
        // const link = document.createElement('a');
        // link.href = url;
        // if (fileName.includes('.' + file.extension)) {
        //   link.setAttribute('download', `${fileName}`);
        // } else {
        //   link.setAttribute('download', `${fileName}.${file.extension}`);
        // }
        // document.body.appendChild(link);
        // link.click();
        window.open(file.url, '_blank').focus();
      },
    },
    watch: {
      chat: {
        handler() {
          if (this.chat.channel_id === 7 && this.activeAudio) {
            this.activeAudio.pause();
            this.activeAudio = null;
          }
        }
      },
    },
  };
  </script>

<style scoped>
.disabled div{
  background-color: #a99a9a5e !important;
}
.headline {
  display: flex;
  align-items: center;
}
.caption-text {
  font-size: 12px;
  text-align: left;
  font-weight: 500;
  margin: 0;
}
.chat-room {
  height: auto;
  background-color: #eceff1 !important;
}
.movement-chip {
  background-color: #fff !important;
  border: 1px solid #ff7c64 !important;
}
.chat-room .message-chip {
  cursor: pointer;
  border-radius: 28px;
  word-break: break-word;
}
.chat-room .message-chip >>> .chip__content {
  cursor: pointer !important;
  display: block;
}
.movement-chip.chip--active:not(.chip--disabled),
.movement-chip.chip--selected:not(.chip--disabled),
.movement-chip.chip:focus:not(.chip--disabled) {
  border: 1px solid #ff7c64 !important;
}
.subName {
  font-size: 12px;
  text-align: left;
  color: #a99a9a;
  font-weight: 500;
}
.position-relative {
  position: relative;
}
</style>


// WEBPACK FOOTER //
// src/components/chat_center_v2/ChatCenterMessage.vue